export default __webpack_public_path__ + "static/media/coding-img.f0116daa.png";